import FiltroActionTypes from './actions';

const startOfDay = new Date();
startOfDay.setUTCHours(0, 0, 0, 0);

const endOfDay = new Date();
endOfDay.setUTCHours(23, 59, 59, 999);

export const FILTRO_INICIAL = {
  periodo: 'hoje',
  dataInicial: startOfDay,
  dataFinal: endOfDay,
  filtrosDrawer: {
    status: [],
    placa: '',
    cpf: '',
    nomeMotorista: '',
    tipoLote: [],
    idTransportadora: [],
  },
  fetchFilterData: true,
};

const denominadorTempo = 1000 * 60 * 60 * 24;

function filtroReducer(state, action) {
  switch (action.type) {
    case FiltroActionTypes.SET_ONTEM:
      return {
        periodo: 'ontem',
        dataInicial: new Date(startOfDay.getTime() - denominadorTempo),
        dataFinal: new Date(endOfDay.getTime() - denominadorTempo),
        filtrosDrawer: state.filtrosDrawer,
        fetchFilterData: true,
      };

    case FiltroActionTypes.SET_HOJE:
      return {
        periodo: 'hoje',
        dataInicial: startOfDay,
        dataFinal: endOfDay,
        filtrosDrawer: state.filtrosDrawer,
        fetchFilterData: true,
      };

    case FiltroActionTypes.SET_AMANHA:
      return {
        periodo: 'amanha',
        dataInicial: new Date(startOfDay.getTime() + denominadorTempo),
        dataFinal: new Date(endOfDay.getTime() + denominadorTempo),
        filtrosDrawer: state.filtrosDrawer,
        fetchFilterData: true,
      };

    case FiltroActionTypes.SET_DATE_PICKER:
      return JSON.parse(
        JSON.stringify({
          ...action.payload,
          filtrosDrawer: state.filtrosDrawer,
          fetchFilterData: true,
        })
      );

    case FiltroActionTypes.CLEAR_FILTRO_DRAWER:
      return {
        periodo: state.periodo,
        dataInicial: state.dataInicial,
        dataFinal: state.dataFinal,
        filtrosDrawer: {
          status: [],
          placa: '',
          cpf: '',
          nomeMotorista: '',
          tipoLote: [],
          idTransportadora: [],
        },
        fetchFilterData: true,
      };

    case FiltroActionTypes.SET_FIELD_DRAWER:
      return {
        ...state,
        filtrosDrawer: {
          ...state.filtrosDrawer,
          ...action.payload,
        },
      };

    case FiltroActionTypes.FETCH_FILTRO_DATA:
      return {
        ...state,
        fetchFilterData: action.payload,
      };

    default:
      throw new Error();
  }
}

export { filtroReducer };
